import { CmsDirectDebitBankInstruction } from './cms-direct-debit-bank-instruction.interface';
import { CmsDirectDebitForm } from './cms-direct-debit-form.interface';
import { CmsDirectDebitGuaranteePanel } from './cms-direct-debit-guarantee-panel.interface';
import { CmsDirectDebitInstructionConfirmation } from './cms-direct-debit-instruction-confirmation.interface';
import { CmsProtectionStartSummaryPanelBoilers } from './cms-protection-start-summary-panel-boilers.interface';
import { CmsProtectionStartSummaryPanelWhiteGoods } from './cms-protection-start-summary-panel-white-goods.interface';

export interface CmsDirectDebitPage
  extends CmsDirectDebitBankInstruction,
    CmsDirectDebitForm,
    CmsDirectDebitGuaranteePanel,
    CmsDirectDebitInstructionConfirmation,
    CmsProtectionStartSummaryPanelBoilers,
    CmsProtectionStartSummaryPanelWhiteGoods {
  pageTitle: string;
}
